import { useMutation, useQuery } from 'react-query';

import { getCookie } from '@/utils';
import * as Types from './user.types';
import * as Repo from './user.repo';

export const useCurrentUser = (hasSessionCookie: boolean, userCode?: string, onSuccess?: (data: any) => void) =>
  useQuery(['getUser'], () => Repo.getUser(), { onSuccess, enabled: hasSessionCookie && !userCode });

// Identidad del admin de la app general vía token Cognito. Habilitado solo si existe
// la cookie `ap_cognito_authorization`; si el token está vencido/ausente, la query
// falla y `data` queda undefined, lo que oculta las afordancias de admin (edición/
// responder reseña). react-query dedupe por key, así que múltiples consumidores
// comparten una sola request.
export const useAdminUser = () => {
  const hasCognitoSession = typeof window !== 'undefined' && !!getCookie('ap_cognito_authorization');

  return useQuery(['getAdminUser'], () => Repo.getAdminUser(), { enabled: hasCognitoSession });
};

export const useLogin = (opts) =>
  useMutation<Types.LoginResponse, Types.LoginError, Types.LoginRequest>(['login'], Repo.login, opts);

export const useCurrentUserByCode = (userCode?: string, onSuccess?: (data: any) => void) =>
  useQuery(['getUserByCode'], () => Repo.getUserByCode({ userCode }), { onSuccess, enabled: !!userCode });
